module.exports = __webpack_public_path__ + "fe29ebaa306b3c7d1d26f3787042f349.MP3";